// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.csi-threeD-snapshots-SnapshotListFilters-module-active {
    background-color: #dadfe8;
    color: #525866;
}`, "",{"version":3,"sources":["webpack://./src/csi/threeD/snapshots/SnapshotListFilters.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,cAAc;AAClB","sourcesContent":[".active {\n    background-color: #dadfe8;\n    color: #525866;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"active": `csi-threeD-snapshots-SnapshotListFilters-module-active`
};
module.exports = ___CSS_LOADER_EXPORT___;
